<template>
  <section class="view-tabs">
    <div
      class="view"
      :class="{ 'view-active': value === view.value }"
      v-for="view of views"
      :key="view.value"
      @click="$emit('change', view.value)"
    >
      <span class="mck3">{{ view.icon }}</span>
      <p>{{ view.name }}</p>
    </div>
  </section>
</template>

<script>
export default {
  props: ["value", "views"],
};
</script>

<style scoped lang="scss">
.view-tabs {
  display: flex;
  gap: 5px;

  .view {
    align-items: center;
    background: #f4f4f4 0% 0% no-repeat padding-box;
    border: 1px solid #cecece;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    gap: 5px;
    text-align: center;
    padding: 5px;
    transition: 0.3s all;

    &.view-active {
      background: #cb6d28;
      color: #ffffff;
    }

    .mck3 {
      font-size: 25px;
    }
    p {
      font-size: clamp(8px, 2vw, 12px);
      font-weight: bold;
    }
  }
}
</style>
